import { Injector } from '@angular/core';
import { registerCustomElements } from '../../custom-elements.definitions';

/**
 * Register all app custom elements (same set as AppElementsModule ngDoBootstrap).
 * Called once from AppModule constructor so CeHostDialog can create any migrated CE.
 */
export function registerGridCustomElements(injector: Injector): void {
  registerCustomElements(injector);
}
